import './style.scss';
import Swiper from 'swiper';
import 'swiper/swiper.scss';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function key_benefits_block() {
    const block = document.querySelector('.key_benefits_block');
    if (!block) return;

    let benefitsSwiper = null;
    const rotateElement = block.querySelectorAll(".svgs-wrapper svg")
    const svgs = gsap.utils.toArray(rotateElement);

    svgs.forEach((svg, i) => {
        gsap.to(svg, {
            rotation: 360,
            transformOrigin: "50% 50%",
            ease: "none",
            scrollTrigger: {
                trigger: block,
                start: "top bottom",
                end: "bottom top",
                scrub: 1,
            },
        });
    });

    function initBenefitsSwiper() {
        const container = document.querySelector('.benefits-swiper');

        if (window.innerWidth < 768) {
            if (!benefitsSwiper) {
                benefitsSwiper = new Swiper(container, {
                    slidesPerView: "auto",
                    spaceBetween: 72,
                    slidesOffsetAfter: 300,
                    //slidesOffsetBefore: 16,
                    observer: true,
                    observeParents: true
                });
            }
        } else {
            if (benefitsSwiper) {
                benefitsSwiper.destroy(true, true);
                benefitsSwiper = null;
            }
        }
    }



    // Run on load
    initBenefitsSwiper();

    // Run on resize
    window.addEventListener('resize', () => {
        initBenefitsSwiper();
    });


}